import Swiper from 'swiper';
import { Navigation, Pagination, EffectCoverflow } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-coverflow';

export function initSpecialSwiper(): void {
  const wrapper = document.querySelector<HTMLElement>('.special-swiper .swiper-wrapper');
  if (!wrapper) return;

  const originals = Array.from(wrapper.children);
  const originalCount = originals.length;

  // Swiper 初期化前にスライドを倍に複製
  originals.forEach((slide) => wrapper.appendChild(slide.cloneNode(true)));

  const swiper = new Swiper('.special-swiper', {
    modules: [Navigation, Pagination, EffectCoverflow],
    effect: 'coverflow',
    centeredSlides: true,
    slidesPerView: 'auto',
    spaceBetween: 40,
    loop: true,
    initialSlide: 0,
    coverflowEffect: {
      rotate: 15,
      stretch: 20,
      depth: 100,
      modifier: 1,
      scale: 0.8,
      slideShadows: false,
    },
    breakpoints: {
      768: {
        spaceBetween: 160,
        coverflowEffect: {
          rotate: 20,
          stretch: 60,
          depth: 200,
          modifier: 1,
          scale: 0.85,
          slideShadows: false,
        },
      },
    },
    navigation: {
      prevEl: '.special-swiper__btn--prev',
      nextEl: '.special-swiper__btn--next',
    },
    pagination: {
      el: '.special-swiper__pagination',
      clickable: true,
      renderBullet(index, className) {
        if (index >= originalCount) return '';
        return `<span class="${className}"></span>`;
      },
    },
    on: {
      realIndexChange(sw) {
        const paginationEl = document.querySelector('.special-swiper__pagination');
        if (!paginationEl) return;
        const bullets = paginationEl.querySelectorAll<HTMLElement>('.swiper-pagination-bullet');
        const activeIdx = sw.realIndex % originalCount;
        bullets.forEach((b, i) =>
          b.classList.toggle('swiper-pagination-bullet-active', i === activeIdx)
        );
      },
    },
  });

  void swiper;
}
